// LessonItem type for TodayLessons
import { z } from 'zod';
import { GetActiveOwnerUpcomingLessonsByIdQuery } from 'types/generated/client';
import { uploadReviewsSchema } from './utils';

// Onboarding step enum
export enum OnboardingStepEnum {
  PROFILE = 'profile',
  SCHEDULE = 'schedule',
  PAYMENTS = 'payments',
}

// Props for ClientActivityCard
export interface Client {
  id: string;
  fullName: string;
  profileImagePath?: string;
}

export interface ClientActivityCardProps {
  value: string;
  trend: number;
  isIncrease: boolean;
  onViewDetails: () => void;
  clients: Client[];
}

// Props for RatingCard
export interface RatingCardProps {
  value: string;
  trend: number;
  isIncrease: boolean;
  trendData: { value: number }[];
  onViewDetails: () => void;
  reviewCount: number;
  children?: React.ReactNode;
}

// Props for RevenueCard
export interface RevenueCardProps {
  value: string;
  trend: number;
  isIncrease: boolean;
  trendData: { value: number }[];
  onViewDetails: () => void;
  children?: React.ReactNode;
}

// Props for Avatar (used in multiple components)
export interface AvatarProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

export type LessonItem = NonNullable<GetActiveOwnerUpcomingLessonsByIdQuery['lessons']>[0];

export interface CompleteCtaProps {
  title: string;
  chances: number;
  onInfoClick: () => void;
  onCtaClick: () => void;
  ctaText: string;
}

export interface InvitePlayerGuideModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export interface InvitePlayersModalProps {
  isOpen: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
}

export type UploadReviewsFormData = z.infer<typeof uploadReviewsSchema>;

export interface VideoCardProps {
  imageSrc: string;
  duration: string;
  badges: string[];
  title: string;
  timeAgo: string;
  youtubeUrl?: string;
}

export interface VideoCardComponentProps extends VideoCardProps {
  onClick: () => void;
}
